/**
 * Legacy-Redirect: /api → /api-docs
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/api')({
  beforeLoad: () => {
    throw redirect({ to: '/api-docs', replace: true })
  },
  component: () => null,
})
